import { useSelector } from 'react-redux'

import { selectFilteredCockpitPartnerData } from '../selectors'
import { ICockpitPartnerData } from '../types'

/** `partnerData` narrowed by RTM plus every active cockpit filter criterion — the source of
 *  truth for "how many/which partners are currently shown" anywhere in the cockpit. */
export const useFilteredCockpitPartnerData = (): ICockpitPartnerData[] => {
  return useSelector(selectFilteredCockpitPartnerData)
}
